import {parseHttpUrl} from '../httpUrl';
import type {Surface} from '../surface';

export const handoffUrl = (
  origins: Partial<Record<Surface, string>> | undefined,
  surface: Surface,
  path = '/'
): string | undefined => {
  const configuredOrigin = origins?.[surface];
  if (!configuredOrigin) {
    return undefined;
  }

  const origin = parseHttpUrl(configuredOrigin);
  if (!origin) {
    return undefined;
  }

  const safePath =
    path.startsWith('/') && !path.startsWith('//') && !path.includes('\\')
      ? path
      : '/';
  const resolved = new URL(safePath, origin);
  return resolved.origin === origin.origin ? resolved.toString() : undefined;
};

// oxlint-disable-next-line wandb/no-unprefixed-urls
export const handOffTo = (url: string) => window.location.assign(url);
